import React from 'react';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

const AssignedDispatchesWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  return (
    <>
      {items.length === 0 && <WidgetEmpty>No documents are assigned to you.</WidgetEmpty>}
      {items.map((d) => (
        <WidgetRow
          key={d.id}
          icon={faPaperPlane}
          tone={d.escalated ? 'error' : 'info'}
          title={d.title}
          subtitle={[d.doc_type_label, d.subtitle].filter(Boolean).join(' · ')}
          right={d.escalated ? <Pill tone="error">Escalated</Pill> : <Age>{d.age_label}</Age>}
          onClick={d.url ? () => goTo(d.url) : undefined}
        />
      ))}
      {data.url && <WidgetFooter label="Open Trade Ops Bunkers" url={data.url} />}
    </>
  );
};

export default AssignedDispatchesWidget;
